"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RRBButton = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Button = _interopRequireDefault(require("../Button"));
var _ReadReceiptBlocking = require("../SecurityMessage/ReadReceiptBlocking");
var _styles = require("@material-ui/core/styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    size: "small",
    onClick: function onClick() {
      return setOpen(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], {
    className: "!text-sm"
  })), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    maxWidth: false,
    open: isOpen,
    onClose: function onClose() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-10",
    style: {
      width: 370
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "read-receipt",
    src: t('read-receipt.png'),
    className: "object-contain h-24"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-lg text-center py-6"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }, "Email tracking"), " is blocked.", /*#__PURE__*/_react["default"].createElement("br", null), " Sender won't see when and where you read messages."), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return setOpen(false);
    }
  }, "Okay, got it")))));
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginTop: 20
    },
    popover: {
      pointerEvents: 'none'
    },
    paper: {
      width: 360,
      boxShadow: '0 0px 20px rgba(0,0,0,.035), 0 0px 20px rgba(0,0,0,.035) !important'
    }
  };
});
var RRBButton = exports.RRBButton = function RRBButton() {
  var classes = useStyles();
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var handlePopoverOpen = function handlePopoverOpen(event) {
    setAnchorEl(event.currentTarget);
  };
  var handlePopoverClose = function handlePopoverClose() {
    setAnchorEl(null);
  };
  var open = Boolean(anchorEl);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-block cursor-default",
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onMouseEnter: handlePopoverOpen,
    onMouseLeave: handlePopoverClose
  }, /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], {
    fontSize: "small",
    className: "text-gray-light opacity-75 hover:opacity-100"
  })), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    open: open,
    disableRestoreFocus: true,
    anchorEl: anchorEl,
    className: classes.popover,
    onClose: handlePopoverClose,
    classes: {
      root: classes.root,
      paper: classes.paper
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dark:shadow-shallow"
  }, /*#__PURE__*/_react["default"].createElement(_ReadReceiptBlocking.Message, null))));
};
//# sourceMappingURL=index.js.map